import { render, staticRenderFns } from "./RightBar.vue?vue&type=template&id=95c2d738&scoped=true&"
import script from "./RightBar.vue?vue&type=script&lang=js&"
export * from "./RightBar.vue?vue&type=script&lang=js&"
import style0 from "./RightBar.vue?vue&type=style&index=0&id=95c2d738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c2d738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VList,VListItem,VNavigationDrawer,VTooltip})
